import { useState } from 'react'
import { Text } from '../forms'
import { PasswordRequirements } from '../widgets'

export const Password = ({ dark, useCurrentPassword, useConfirmedPassword, showPasswordRequirements }) => {
  const [passwordVisible, setPasswordVisible] = useState(false)

  const passwordProps = {
    type: passwordVisible ? 'text' : 'password',
    rightIcon: passwordVisible ? 'Hide' : 'Show',
    rightIconAction: () => setPasswordVisible(!passwordVisible),
    required: true,
    dark: dark
  }

  const validatePassword = (confirmedPassword, { password }) => confirmedPassword !== password && 'Passwords do not match'

  return (
    <>
      {useCurrentPassword &&
        <Text
          title="Password"
          name="oldPassword"
          {...passwordProps}
        />
      }
      <Text
        title={`${useCurrentPassword ? 'New p' : 'P'}assword`}
        name="password"
        {...passwordProps}
      />
      {useConfirmedPassword &&
        <Text
          title="Confirm password"
          name="confirmedPassword"
          {...passwordProps}
          getValidationMessage={validatePassword}
        />
      }

      {showPasswordRequirements && <PasswordRequirements dark={dark}/>}
    </>
  )
}